import React from 'react';
import { Link } from 'react-router-dom';
import KpiBox from './KpiBox';
import ListingInfo from './ListingInfo';

const Listings = ({ listings = [], count, query = '', onQueryChange }) => {
  return (
    <div className="listings-container">
      <div className="listings-header">
        <Link to="/listings" className="view-all-button">View all listings</Link>
        <span className="listings-count">{count ?? listings.length} in view</span>
      </div>
      <input
        type="search"
        className="listings-search"
        placeholder="Filter listings (address, eircode, broker, BER...)"
        value={query}
        onChange={(e) => onQueryChange && onQueryChange(e.target.value)}
      />
      <KpiBox listings={listings} />
      {listings?.length > 0 ? (
        listings.map(listing => (
          <div key={listing.id} className="listing-card">
            <h3>{listing.title}</h3>
            <ListingInfo listing={listing} />
            {listing.image_url && (
              <img
                src={listing.image_url}
                alt={listing.title}
                className="listing-image"
              />
            )}
          </div>
        ))
      ) : (
        <div>No listings found</div>
      )}
    </div>
  );
};

export default Listings;